import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(3),

    '& .about-text-container': {
      padding: theme.spacing(3),
      ...theme.typography.body2,
      wordBreak: 'break-word',
      color: theme.palette.text.primary,
    },

    '& .btn-new-appointment': {
      height: theme.spacing(8),
      backgroundColor: theme.palette.custom.background.area,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: theme.spacing(0, 3),
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[25],
      color: theme.palette.custom.feedback.positive,
      marginTop: theme.spacing(3),

      '&-icon': {
        '&-before': {
          marginRight: theme.spacing(2),
        },
        '&-after': {
          marginLeft: 'auto',
        },
      },
      '&-text': {},
    },
  },
}));

export default styles;
